import React from 'react';
import { Link } from 'react-router-dom';
import { GeocodedAddress } from './AdherentMapTypes';

interface AdherentMapPopupProps {
  address: GeocodedAddress;
}

export const AdherentMapPopup: React.FC<AdherentMapPopupProps> = ({ address }) => {
  // Format the adherent address with proper components
  const formattedAddress = `${address.numeroVoirie || ''} ${address.libelleVoie || ''}`.trim();
  const formattedCommune = address.commune || '';
  const fullAddress = [
    formattedAddress,
    `${address.codePostal || ''} ${formattedCommune}`.trim()
  ].filter(Boolean).join(', ');

  // Get the appropriate name to display with proper type checking and optional chaining
  const hasIndividualName = Boolean(address.prenom1UniteLegale && address.nomUniteLegale);
  const displayName = hasIndividualName
    ? `${address.prenom1UniteLegale} ${address.nomUniteLegale}`
    : address.denominationUniteLegale || address.denominationUsuelleEtablissement || 'Entreprise';

  return (
    <div className="min-w-[300px] max-w-md">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-900">
          {displayName}
        </h3>
        <p className="text-sm font-medium text-gray-600">
          SIRET: {address.siret}
        </p>
      </div>

      <div className="mb-4">
        <h4 className="text-sm font-medium text-gray-700 mb-1">Adresse</h4>
        <p className="text-sm text-gray-600">{fullAddress || 'Adresse non disponible'}</p>
      </div>

      {address.adherentId && (
        <div className="mt-4 flex justify-end">
          <Link 
            to={`/adherents/${address.adherentId}`}
            className="inline-flex items-center px-4 py-2 bg-white border border-primary-600 text-primary-600 text-sm font-medium rounded-md hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            Voir détails
          </Link>
        </div>
      )}
    </div>
  );
}; 